import { isDev } from './utils/is-dev';
import { API_HOST_MAP, IS_TRIAL_DEMO } from '@meego/biz-constants';

const hostName = IS_TRIAL_DEMO ? `https://${API_HOST_MAP[window.location.host]}` : '';

export const REMOTE_MODULE_MANIFEST_PATH = {
  '@meego-remote/onboarding': `${hostName}/b/onboarding/remote-module/mf-manifest.json`,
  '@meego-remote/openapp': `${hostName}/b/openapp/remote-module/mf-manifest.json`,
  '@meego-remote/platform': `${hostName}/b/platform/remote-module/mf-manifest.json`,
  '@meego-remote/enterprise': `${hostName}/b/enterprise/remote-module/mf-manifest.json`,
  '@meego-remote/metrics': `${hostName}/b/metrics/remote-module/mf-manifest.json`,
  '@meego-remote/automation': `${hostName}/b/automation/remote-module/mf-manifest.json`,
  '@meego-remote/expression': `${hostName}/b/expression/remote-module/mf-manifest.json`,
  '@meego-remote/ipd': `${hostName}/b/ipd/remote-module/mf-manifest.json`,
  '@meego-remote/widget/ui-components': `${hostName}/b/widget/remote-module/ui-components/mf-manifest.json`,
  '@meego-remote/ai': `${hostName}/b/ai/remote-module/mf-manifest.json`,
  '@meego-remote/core': `${hostName}/b/core/remote-module/mf-manifest.json`,
  '@meego-remote/view': `${hostName}/b/view/remote-module/mf-manifest.json`,
  '@meego-remote/builder': `${hostName}/b/builder/remote-module/mf-manifest.json`,
  '@meego-remote/workitem': `${hostName}/b/workitem/remote-module/mf-manifest.json`,
};

if (isDev) {
  /**
   * 本地调试时，缺少SSG，手动注入一下
   *
   * 在标准场景下，__MEEGO_HOST_MANIFESTS_SSG__来自html中的注入内容
   * 用不同的环境参数启动，注入的内容不一样。
   * 这个值未经这里的覆盖的话，会导致主仓的remoteEntry url一直是构建时的域名，
   * 无法支持在一次构建多环境可使用
   * 这里提前一下手动注入SSG的时机，让这个注入也能覆盖到hostManifestMap
   */
  window.__MEEGO_HOST_MANIFESTS_SSG__ = `//${window.location.host}/static/js/meego_remote.js`;
}

/**
 * 注意 @meego-remote 和 @meego-remote/main 指向同一个模块，
 * 原因是这个名称有变更，做一下前后兼容
 */
export const hostManifestMap = {
  '@meego-remote/main': {
    // 使用时的名称，可自由定义，e.g. @meego-remote/onboarding
    alias: '@meego-remote/main',
    // webpack 打包用的 name，会被当作变量放进代码中，因此不能包含特殊字符
    name: 'meego_remote',

    buildInfoHash: window.__MEEGO_HOST_BUILD_INFO_HASH__ || '', // 打包时注入，mf-build-info 的 hash，用于获取当前版本的 mf-build-info
    publicPath: window.__MEEGO_HOST_PUBLIC_PATH__ || '', // 打包时注入，模块的 publicPath，用于获取模块下的资源
    // 通过独立打包获得的 meta
    remoteEntry: {
      url: window.__MEEGO_HOST_MANIFESTS_SSG__, // 打包时注入的
    },
    // 是否跳过 window 上变量的清理，host manifest 专用
    skipClear: true,
  },
  '@meego-remote': {
    // 使用时的名称，可自由定义，e.g. @meego-remote/onboarding
    alias: '@meego-remote',
    // webpack 打包用的 name，会被当作变量放进代码中，因此不能包含特殊字符
    name: 'meego_remote',

    buildInfoHash: window.__MEEGO_HOST_BUILD_INFO_HASH__ || '', // 打包时注入，mf-build-info 的 hash，用于获取当前版本的 mf-build-info
    publicPath: window.__MEEGO_HOST_PUBLIC_PATH__ || '', // 打包时注入，模块的 publicPath，用于获取模块下的资源
    // 通过独立打包获得的 meta
    remoteEntry: {
      url: window.__MEEGO_HOST_MANIFESTS_SSG__, // 打包时注入的
    },
    // 是否跳过 window 上变量的清理，host manifest 专用
    skipClear: true,
  },
};
